import { Component } from 'react';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import { colorToRGBA } from '@synergy/utils';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            marginTop: theme.spacing(2),
            marginLeft: theme.spacing(3),

            '& div:first-child': {
                display: 'inline-flex',
                userSelect: 'none',
                justifyContent: 'center',
                alignItems: 'center',
                width: theme.spacing(4),
                height: theme.spacing(4),
                marginRight: theme.spacing(),
                borderRadius: '50%',
                backgroundColor: '#1961AC;',
                color: theme.palette.common.white,
            },

            '& div:last-child': {
                display: 'inline-flex',
                flexDirection: 'column',

                '& > span': {
                    fontSize: '11px',
                    lineHeight: 1,
                },

                '& > span:first-child': {
                    color: '#21272E',
                },

                '& > span:last-child': {
                    paddingTop: '4px',
                    color: colorToRGBA('#21272E', 0.6),
                },
            },
        },
    });

interface PoolAuthorProps extends WithStyles<typeof styles> {
    shorthand: string;
    name: string;
    company: string;
}

export const PoolAuthor = withStyles(styles)(
    class PoolAuthorBase extends Component<PoolAuthorProps> {
        public override render() {
            const { classes, shorthand, name, company } = this.props;

            return (
                <div className={classes.root}>
                    <div>{shorthand}</div>
                    <div>
                        <span>{name}</span>
                        <span>{company}</span>
                    </div>
                </div>
            );
        }
    }
);
